import React, { useEffect, useState } from 'react';

import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { DATE_RANGE_PROPS, ORDER_STATUS_PROPS } from '../../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_CSV];

const filtersProps = [ORDER_STATUS_PROPS, DATE_RANGE_PROPS];

const BuyerComments = () => {
  const [updatedFiltersProps, setUpdatedFiltersProps] = useState(filtersProps);

  useEffect(() => setUpdatedFiltersProps(buildDropdownOptions({ filtersProps })), []);

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default BuyerComments;
